import { forwardRef } from 'react'
import {
  Flex,
  Box,
  ThemeUIStyleObject,
  SelectProps as ThemeUISelectProps,
} from 'theme-ui'
import { ChevronDownIcon } from 'components/Icon'

export type SelectProps = ThemeUISelectProps & {
  children: JSX.Element | JSX.Element[]
  selectSx?: ThemeUIStyleObject
}

const sx: ThemeUIStyleObject = {
  appearance: 'none',
  width: '100%',
  minWidth: 80,
  p: 4,
  bg: 'oldlace',
  border: 'solid 2px transparent',
  outline: 'none',
  fontFamily: 'body',
  fontSize: [1, 2],
  borderRadius: 8,
  '&:focus': {
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'primary',
  },
}

export const Select = forwardRef<HTMLSelectElement, any>(
  ({ children, selectSx = {}, chevronSx = {}, ...rest }, ref) => (
    <Flex sx={{ alignItems: 'center' }}>
      <Box as="select" ref={ref as any} sx={{ ...sx, ...selectSx }} {...rest}>
        {children}
      </Box>
      <Box sx={{ pointerEvents: 'none', marginLeft: -28, ...chevronSx }}>
        <ChevronDownIcon />
      </Box>
    </Flex>
  )
)
